// Pages
import Login from "./pages/login";
import Logout from "./pages/login/logout";
import Dashboard from "./pages/dashboard";
import Pedidos from "./pages/pedidos";
import View from "./pages/pedidos/view";
import Productos from "./pages/productos";
import HistorialDeVersiones from "./pages/about";
import Abaout from "./pages/about/about";
import Logs from "./pages/logs"

const routes = [
  {
    route: "/dashboard",
    component: <Dashboard />,
    role: "admin",
  },
  {
    route: "/pedidos",
    component: <Pedidos />,
    role: "admin",
  },
  {
    route: "/total-productos",
    component: <Productos />,
    role: "admin",
  },
  {
    route: "/pedidos/:id",
    component: <View />,
    role: "admin",
  },

  {
    route: "/login",
    role: "auth",
    component: <Login />,
  },
  {
    route: "/logout",
    component: <Logout />,
  },
  {
    route: "/about/versions",
    component: <HistorialDeVersiones />,
  },
  //--------------DASHBOARD ROUTES----------------
  {
    route: "/about",
    component: <Abaout />,
  },
  {
    route: "/logs",
    component: <Logs />,
  },
];

export default routes;
